import TheNav from "../Components/navbar"
import SEO from "../Components/SEO";

export default function Error() {
    return (
        <>
            <SEO
                title="Page Not Found | Kre8"
                description="This Kre8 Content page could not be found."
                canonicalPath="/404"
                noindex
            />
            <TheNav />
            <main className="mobile-safe grid min-h-screen place-items-center overflow-hidden bg-[#07060d] px-4 py-20 text-white sm:px-6 lg:px-8">
                <div aria-hidden className="pointer-events-none absolute left-1/2 top-28 h-72 w-72 -translate-x-1/2 rounded-full bg-[#9146FF]/20 blur-3xl" />
                <div className="relative w-full max-w-xl rounded-3xl border border-white/10 bg-white/[0.035] p-8 text-center shadow-[0_30px_100px_-60px_rgba(132,255,0,0.6)] backdrop-blur-xl sm:p-10">
                    <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#84ff00]">Error 404</p>
                    <h1 className="mt-4 text-3xl font-black tracking-tight text-white sm:text-5xl">Page not found</h1>
                    <p className="mx-auto mt-5 max-w-md text-sm leading-7 text-zinc-400">
                        This page is off the map. Head back to the editor directory and keep moving.
                    </p>
                    <a
                        href="/gaming-video-editors"
                        className="mt-8 inline-flex items-center justify-center rounded-full bg-[#84ff00] px-5 py-3 text-sm font-bold text-black transition hover:brightness-110"
                    >
                        Browse Editors
                    </a>
                </div>
            </main>
        </>
    )
}
